import PropTypes from "prop-types";

export const auditFeatures = PropTypes.shape({
  auditModeSearch: PropTypes.bool,
});
